import React from 'react';
import { CellProps } from 'react-table';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { IServiceType } from 'src/types/service-types';
import { resendEmailLog } from 'src/store/actions/emails-log-actions';
import styles from '../assets/emails-log-actions.module.scss';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const EmailsLogActionsColumn: React.FunctionComponent<CellProps<IServiceType>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IServiceType>) => {
    const dispatch = useDispatch();

    return (
        <div className={classNames(styles.actions)}>
            <button
                className={'btn btn-info'}
                type={'button'}
                onClick={() =>
                    dispatch(
                        resendEmailLog(
                            original.id,
                            () => toast.success(`Email was resend successfully`),
                            (errorMessage: string) => {
                                toast.error(errorMessage);
                            },
                        ),
                    )
                }
            >
                <FontAwesomeIcon icon={faEnvelope} />
            </button>
        </div>
    );
};

export default EmailsLogActionsColumn;
